export const SETTINGS = [
    {
        icon: 'mdi-hospital-marker',
        label: 'common.locationsTitle',
        to: { name: 'settings.locations' },
        access: 'settings.locations',
    },
    {
        icon: 'mdi-book-open-variant',
        label: 'common.dictionary',
        to: { name: 'settings.dictionary' },
        access: 'settings.dictionary',
    },
    {
        icon: 'mdi-slot-machine',
        label: 'machinesAndToolsDefinitions.machinesAndToolsDefinitions',
        to: { name: 'settings.equipment-types' },
        access: 'settings.equipment-types',
    },
    {
        icon: 'mdi-folder',
        label: 'common.categories',
        to: { name: 'settings.categories' },
        access: 'settings.categories',
    },
    {
        icon: 'mdi-history',
        label: 'common.shifts',
        to: { name: 'settings.shifts-schemas' },
        access: 'settings.shifts-schemas',
    },
    // {
    //     icon: 'mdi-calendar-account-outline',
    //     label: 'common.workSchemas'),
    //     to: { name: 'settings.work-schemas' },
    //     access: 'settings.work-schemas',
    // },
    {
        icon: 'mdi-cash-fast',
        label: 'costCenter.costCenter',
        to: { name: 'settings.cost-centers' },
        access: 'settings.cost-centers',
    },
    {
        icon: 'mdi-domain',
        label: 'common.companyData',
        to: { name: 'settings.companyManagement' },
        access: 'settings.companyManagement',
    },
    {
        icon: 'mdi-tablet-dashboard',
        label: 'common.terminals',
        to: { name: 'terminals' },
        access: 'terminals',
    },
    {
        icon: 'mdi-sync',
        label: 'common.synchronization',
        to: { name: 'settings.synchronization' },
        access: 'settings.synchronization',
    },
    {
        icon: 'mdi-clipboard-alert',
        label: 'issues.issues',
        to: { name: 'settings.issues' },
        access: 'settings.issues',
    },
    {
        icon: 'mdi-account-hard-hat',
        label: 'common.crews',
        to: { name: 'settings.crews' },
        access: 'settings.crews',
    },
    {
        icon: 'mdi-source-repository',
        label: 'common.externalSystems',
        to: { name: 'settings.systems' },
        access: 'settings.systems',
    },
    {
        icon: 'mdi-badge-account-horizontal-outline',
        label: 'common.staffProfiles',
        to: { name: 'settings.userProfiles' },
        access: 'settings.staff',
    },
    {
        icon: 'mdi-meter-electric-outline',
        label: 'common.metersSettings',
        to: { name: 'settings.meters-settings' },
        access: 'settings.counters',
    },
    {
        icon: 'mdi-state-machine',
        label: 'common.equipmentStates',
        to: { name: 'settings.equipment_states' },
        access: 'settings.equipment_states',
    },
    {
        icon: 'mdi-database',
        label: 'common.indexes',
        to: { name: 'settings.indexes' },
        access: 'settings.indexes',
    },
    {
        icon: 'mdi-factory',
        label: 'common.plants',
        to: { name: 'settings.plants' },
        access: 'settings.plants',
    },
    {
        icon: 'mdi-flag',
        label: 'common.flags',
        to: { name: 'settings.flags' },
        access: 'settings.flags',
    },
    {
        icon: 'mdi-briefcase',
        label: 'common.workOrderTemplates',
        to: { name: 'settings.work_order_templates' },
        access: 'work_order_templates',
    },
];
